export const FEATURE_FLAGS = {
    BUDDI_BOT: 'show_buddi_bot_sidebar_item',
    JOBS: 'show_jobs_sidebar_item',
    DOCUMENTS: 'show_documents_sidebar_item',
    WALLET: 'show_buddi_wallet_sidebar_item',
    PERSONAL_NETWORKS: 'show_personal_networks_sidebar_item',
    MESSAGES: 'show_messages_sidebar_item',
    TRANSACTIONS: 'show_transactions_sidebar_item',
    CREATE_COMPANY: 'show_create_company_button',
};